<div class="MainContainer">
    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'Spendings' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
            <button (click)="InitializeNewSpending();closeAllFirst();" style="padding-left: 10px;" mat-raised-button color="primary"><i class="material-icons">add</i> {{'Spending' | translate}}</button>
        </div>
    </div>

    <div *ngIf="ShowNewSpendingContainer" class="animated fadeInDown NewPartnerPopUp">
      <div class="PopUpCloseContainer" (click)="ShowNewSpendingContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="PopUpTitleContainer">
       <p>{{ 'AddNewSpending' | translate }}</p>
      </div>

      <div class="PopUpBody">

        <div class="ReceptionProductsRow ReceptionProductsRowHover NewSpendingRow" style="background: transparent;">
                   
          <div class="ReceptionProductsCol" style="width: 20%;font-weight: 500;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'Receptions.SearchSupplier' | translate }}*</mat-label>
                  <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="GetPartnersFiltered(this.searchTerm, this.countryID, true);">
                  <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                  <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                </mat-form-field>

                <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                  <div class="PartnerSearchResultNewSpending" *ngFor="let p of Partners" (click)="SelectSpendingPartner(p);resultsLength = 0;this.searchTerm=p.Name;">
                      <p class="SearchResultTitleNewSpending">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT.length;">{{p.VAT}}</span></p>
                  </div>
                </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 12.5%;text-align: left;padding-left: 1%;">
              <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'CreatingDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="dp3" [formControl]="CreatingDate" [(ngModel)]="currentSpending.DocumentDate">
                  <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                  <mat-datepicker #dp3></mat-datepicker>
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 12.5%;">
              <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'DueDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="dp4" [formControl]="DueDate" [(ngModel)]="currentSpending.DueDate">
                  <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                  <mat-datepicker #dp4></mat-datepicker>
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'Value' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'Value' | translate }}" autocomplete="off" [(ngModel)]="currentSpending.Value" (change)="SelectSpendingPartner(currentSpending.Partner);VerifyPriceModel(currentSpending.Value);">
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{ 'CollectedVAT' | translate }}</mat-label>
                  <mat-select name="CollectedVAT" [(ngModel)]="currentSpending.VAT" [compareWith]="compareFn">
                    <mat-option *ngFor="let v of this.VATRates;" [value]="v" (click)="SelectSpendingPartner(currentSpending.Partner);">
                      {{v.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'PaidValue' | translate }}*</mat-label>
                  <input disabled="disabled" matInput placeholder="{{ 'PaidValue' | translate }}" autocomplete="off" [(ngModel)]="currentSpending.PaidValue" (change)="SelectSpendingPartner(currentSpending.Partner);">
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                  <mat-label>{{ 'VATPaidValue' | translate }}*</mat-label>
                  <input disabled="disabled" matInput placeholder="{{ 'VATPaidValue' | translate }}" autocomplete="off" [(ngModel)]="currentSpending.VATPaidValue">
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{ 'Currency' | translate }}</mat-label>
                  <mat-select name="Currency" [(ngModel)]="currentSpending.Currency" [compareWith]="compareFn">
                    <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            ---
          </div>
      </div>

      <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;border: none;">
        <div class="ReceptionProductsCol" style="width: 15%;margin-left: 2%;">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'Deductibility' | translate }}</mat-label>
            <mat-select name="Deductibility" [compareWith]="compareFn" [(ngModel)]="currentSpending.Deductibility.Type">
              <mat-option *ngFor="let d of this.DeductibilityTypes" [value]="d">
                {{d.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ReceptionProductsCol" style="width: 15%;margin-left: 2%;">
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'Deductibility' | translate }}</mat-label>
                <input matInput placeholder="{{ 'Deductibility' | translate }}" autocomplete="off" [(ngModel)]="currentSpending.Deductibility.Value">
            </mat-form-field>
        </div>
      </div>

      <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;">
        <div class="ReceptionProductsCol" style="width: 35%;text-align: left;">
          <mat-form-field appearance="outline" class="ReceptionProductsColSearch" style="width: 100%;">
            <mat-label>{{ 'Description' | translate }}</mat-label>
            <textarea autocomplete="off" matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="5"
                      cdkAutosizeMaxRows="5"
                      [(ngModel)]="currentSpending.Description"></textarea>
          </mat-form-field>
        </div>
        <div class="ReceptionProductsCol" style="width: 20%;padding-left: 1%;">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
            <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="currentSpending.DecimalPrecision">
              <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p">
                {{p.Meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="ReceptionProductsCol" style="width: 20%;">
          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'Receptions.DocNumber' | translate }}</mat-label>
            <input matInput placeholder="{{ 'Receptions.DocNumber' | translate }}" autocomplete="off" [(ngModel)]="currentSpending.DocumentNumber">
          </mat-form-field>
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
          <button (click)="currentSpending = s;RemoveSpendingFile(currentSpending.ID);" style="height: 30px;line-height: 30px;" mat-raised-button color="warn" *ngIf="currentSpending.FilePath != null;">{{ 'RemoveFile' | translate }}</button>
        </div>
        <div class="ReceptionProductsCol" style="width: 15%;">
          <form [formGroup]="newBlogForm" style="width: auto;float: left;">
            <div style="margin-bottom: 10px;">
                <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" style="width: 80%;">
            </div>
          </form>
        </div>
    </div>

    <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;">
      <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="s != null;">
        <button mat-raised-button color="accent" (click)="AddUpdateSpending(s);">{{'Update' | translate}}</button>
    </div>
     <div class="ReceptionProductsCol" style="width: 10%;" *ngIf="s != null;">
      <button mat-raised-button color="warn" *ngIf="currentSpending.DocumentStatus.ID != -1;" (click)="CancelOrActivateSpending(currentSpending.ID, true);">{{ 'Cancel' | translate }}</button>
      <button mat-raised-button color="primary" *ngIf="currentSpending.DocumentStatus.ID == -1;" (click)="CancelOrActivateSpending(currentSpending.ID, false);">{{ 'Activate' | translate }}</button>
     </div>
    </div>
        

      </div>

      <div class="PopUpCommands">
        <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="AddUpdateSpending(currentSpending);">{{ 'AddNewSpending' | translate }}</button>
      </div>
    </div>

    <div *ngIf="ShowPaymentsContainer" class="animated fadeInDown NewPartnerPopUp">
      <div class="PopUpCloseContainer" (click)="ShowPaymentsContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="PopUpTitleContainer">
       <p>{{ 'Payments' | translate }}</p>
      </div>

      <div class="PopUpBody">

        <div class="ReceptionProductsContainer">
          
          <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
              <div class="ReceptionProductsCol" style="width: 15%;">
                {{ 'Supplier' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'PaymentDate' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'Value' | translate }} 
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{ 'PaymentType' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  {{ 'Currency' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  {{ 'Receptions.ExchangeRate' | translate }}
                </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                {{ 'Receptions.DecimalPercision' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 30%;">
                  {{ 'CollectionExternalID' | translate }}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'Actions' | translate }}
              </div>
          </div>

          <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
              <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>

          <div *ngIf="!loading">
              <div class="ReceptionProductsRow" *ngFor="let c of this.SpendingPayments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Category.ID == -1, 'AssociatedPayment': c.Category.ID == 0, 'AssociatedSpending': c.Category.ID == 1}">
                  <div class="ReceptionProductsCol" style="width: 15%;">
                      <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                      <span *ngIf="c.Status.ID == -1;color">[ {{c.Status.Name}} ]</span>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.PaymentDateUI}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.Value}} 
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.Type.Name}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 5%;">
                      {{c.Currency.Name}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 5%;">
                      <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                      <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                    </div>
                  <div class="ReceptionProductsCol" style="width: 5%;">
                      {{c.Currency.DecimalPrecision.ID}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 30%;">
                      {{c.PaymentExternalID}}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      <i class="material-icons ReceptionProductEdit" (click)="ClonePayment(c); ShowPaymentContainer = true;">edit</i>
                      <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeletePaymentQuestion = true;">close</i>
                  </div>
              </div>
          </div>

          <div *ngIf="this.SpendingPayments != null && this.SpendingPayments.length > 0 && !loading;">
              <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.PaymentsTotals; let i=index;">
                  <div class="ReceptionProductsCol" style="width: 10%;">
      
                  </div>
                  <div class="ReceptionProductsCol" style="width: 15%;">
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      Total:
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                    <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      {{Total.Currency.Name}}
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol" style="width: 20%;">
                    
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      
                  </div>
              </div>
          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && SpendingPayments.length > 0;">
              <div class="ReceptionProductsCol" style="width: 10%;">
        
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex - 1);">
                  <i class="material-icons">chevron_left</i>
                </button>
        
                <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
                  <i class="material-icons">chevron_left</i>
                </button>
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetPaymentsFiltered(this.Filter.Pager.PageIndex + 1);">
                  <i class="material-icons">chevron_right</i>
                </button>
        
                <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
                  <i class="material-icons">chevron_right</i>
                </button>
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;">
                  
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  
              </div>
          </div>
   
      </div>

      </div>

      <div class="PopUpCommands">


      </div>

    </div>

    <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
      <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
        <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">

          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'PaymentType' | translate }}</mat-label>
              <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
                <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                  {{type.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Currency' | translate }}</mat-label>
              <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
                <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
              <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
                <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                  {{b.DisplayValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
              <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
              <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
              <mat-icon matSuffix>calculate</mat-icon>
            </mat-form-field>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
              <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
                <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                  {{d.Meaning}}
                </mat-option>
              </mat-select>
            </mat-form-field>

        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
          <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value">
          <mat-icon matSuffix>monetization_on</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
          <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
          <mat-icon matSuffix>qr_code_2</mat-icon>
        </mat-form-field>
       </div>

       <div class="PopUpCommands">
        <button *ngIf="this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="UpdatePayment(this.currentPayment);ShowPaymentContainer = false;">
            <span>{{'UpdatePayment' | translate}}</span>
        </button>
        <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPayment();ShowPaymentContainer = false;">
            <span>{{'AddPayment' | translate}}</span>
        </button>
      </div>
  </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteSpending(currentSpending.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeletePaymentQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeletePaymentQuestion = false; currentSpending = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeletePaymentQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowAutoPrintBulkQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowAutoPrintBulkQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'AutoPrintBulkTitle' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'AutoPrintBulkDescription' | translate }}
      </div>
    
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false;">{{ 'No' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false; AutoPrintSpendings();">{{ 'Yes' | translate }}</button>
      </div>
    </div>

    <div class="overlay" *ngIf="ShowAutoPrintBulkQuestion || ShowPaymentsContainer || ShowNewSpendingContainer || ShowDeleteSpendingQuestion || ShowPaymentContainer;" (click)="ShowNewSpendingContainer = false; ShowDeleteSpendingQuestion = false;"></div>

    <div class="MainTitleBar" style="overflow: hidden;" *ngIf="Countries != null;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetSpendingsFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetSpendingsFiltered();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
    </div>

      <div class="MainTitleBar" style="overflow: unset;" *ngIf="Countries != null;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>

        <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="this.AnyChecked" (click)="ShowAutoPrintBulkQuestion = true;" >
          <i class="material-icons">print</i>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                  
                </div>
                 
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>Doc.Status</mat-label>
                        <mat-select name="Series" [(ngModel)]="Filter.DocumentStatus">
                          <mat-option *ngFor="let d of this.DocumentStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'DocStatus');">
                            {{d.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'Currency' | translate}}</mat-label>
                        <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                          <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
    
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                        <mat-label>{{ 'Receptions.SearchSupplier' | translate }}*</mat-label>
                        <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="GetPartnersFiltered(this.searchTerm, this.countryID, true);">
                        <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                        <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                      </mat-form-field>
    
                      <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                        <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                            <p class="SearchResultTitle">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT.length;">{{p.VAT}}</span></p>
                        </div>
                      </div>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'ClientCountry' | translate}}</mat-label>
                        <mat-select name="Country" [(ngModel)]="Filter.Country">
                          <mat-option *ngFor="let c of this.Countries;" [value]="c" (click)="AddActiveFilter(c.Name, 'Country');">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
              
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetSpendingsFiltered();">{{ 'FilterInvoices' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.Spendings.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Spendings' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetSpendingsFiltered(1);">
            </mat-form-field>
          </div>
        </div>
       
        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetSpendingsFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetSpendingsFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
      </div>

    <div class="MainBody">

      <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
      </div>

        <div class="ReceptionProductsContainer animated fadeIn" *ngIf="!loading;">
          <mat-accordion #firstAccordion="matAccordion">

              <mat-expansion-panel disabled>
                <mat-expansion-panel-header style="background: #2f313a;">
                  <mat-panel-description style="width: 5%;" class="panelTitleCol">
                    <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
                  </mat-panel-description>
                  <mat-panel-description style="width: 15%;" class="panelTitleCol">
                    <span>{{ 'Supplier' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 12.5%;" class="panelTitleCol">
                    <span>{{ 'CreatingDate' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 12.5%;" class="panelTitleCol">
                    <span>{{ 'DueDate' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelTitleCol">
                    <span>{{ 'Value' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelTitleCol">
                    <span>{{ 'CollectedVAT' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelTitleCol">
                    <span>{{ 'PaidValue' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelTitleCol">
                    <span>{{ 'VATPaidValue' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 7.5%;" class="panelTitleCol">
                    <span>{{ 'Currency' | translate }}</span>
                  </mat-panel-description>
                  <mat-panel-description style="width: 7.5%;" class="panelTitleCol">
                    <span>{{ 'Status' | translate }}</span>
                  </mat-panel-description>
                </mat-expansion-panel-header>
              </mat-expansion-panel>
    
            <mat-expansion-panel *ngFor="let s of this.Spendings; index as i" (opened)="OpenSpendingEdit(s);" [ngClass]="{'deactivatedReception': s.DocumentStatus.ID == -1}">
              <mat-expansion-panel-header class="ExpandHeadder">
                <mat-panel-title style="width: 5%;" class="panelCol">
                  <mat-checkbox class="tableColCheckBox" [(ngModel)]="s.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                  <span class="PanelColIndex">{{i + 1}}</span>
                </mat-panel-title>
                <mat-panel-description style="width: 15%;" class="panelCol">
                  <p>{{s.Partner.Name}}</p>
                </mat-panel-description>
                <mat-panel-description style="width: 12.5%;" class="panelCol">
                  <p>{{s.DocumentDateUI}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 12.5%;" class="panelCol">
                    <p>{{s.DueDateUI}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelCol">
                    <p>{{s.Value}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelCol">
                    <p>{{s.VATValue}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelCol">
                    <p>{{s.PaidValue}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 10%;" class="panelCol">
                    <p>{{s.VATPaidValue}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 7.5%;" class="panelCol">
                    <p>{{s.Currency.Name}}</p>
                  </mat-panel-description>
                  <mat-panel-description style="width: 7.5%;" class="panelCol">
                    <span [ngClass]="{'CancelledStatus': s.DocumentStatus.ID == -1, 'CollectedStatus': s.DocumentStatus.ID == 1,'PartiallyCollected': s.DocumentStatus.ID == 2,'SurplusCollected': s.DocumentStatus.ID == 3, 'CreatedStatus': s.DocumentStatus.ID == -99, 'Overdue': s.DocumentStatus.ID == 4}">{{s.DocumentStatus.Name}}</span>
                  </mat-panel-description>
              </mat-expansion-panel-header>
    
              <div class="ExpansionBody">
                <div class="ReceptionProductsRow ReceptionProductsRowHover NewSpendingRow" style="background: transparent;">
                   
                  <div class="ReceptionProductsCol" style="width: 20%;font-weight: 500;">
                      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                          <mat-label>{{ 'Receptions.SearchSupplier' | translate }}*</mat-label>
                          <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="GetPartnersFiltered(this.searchTerm, this.countryID, true);">
                          <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                          <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                        </mat-form-field>
      
                        <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                          <div class="PartnerSearchResultNewSpending" *ngFor="let p of Partners" (click)="SelectSpendingPartner(p);resultsLength = 0;this.searchTerm=p.Name;">
                              <p class="SearchResultTitleNewSpending">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT.length;">{{p.VAT}}</span></p>
                          </div>
                        </div>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 12.5%;text-align: left;padding-left: 1%;">
                      <mat-form-field appearance="outline" style="width: 100%;">
                          <mat-label>{{ 'CreatingDate' | translate }}</mat-label>
                          <input matInput [matDatepicker]="dp3" [formControl]="CreatingDate" [(ngModel)]="s.DocumentDate">
                          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                          <mat-datepicker #dp3></mat-datepicker>
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 12.5%;">
                      <mat-form-field appearance="outline" style="width: 100%;">
                          <mat-label>{{ 'DueDate' | translate }}</mat-label>
                          <input matInput [matDatepicker]="dp4" [formControl]="DueDate" [(ngModel)]="s.DueDate">
                          <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                          <mat-datepicker #dp4></mat-datepicker>
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                          <mat-label>{{ 'Value' | translate }}*</mat-label>
                          <input matInput placeholder="{{ 'Value' | translate }}" autocomplete="off" [(ngModel)]="s.Value" (change)="SelectSpendingPartner(s.Partner);VerifyPriceModel(s.Value);">
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                          <mat-label>{{ 'CollectedVAT' | translate }}</mat-label>
                          <mat-select name="CollectedVAT" [(ngModel)]="s.VAT" [compareWith]="compareFn">
                            <mat-option *ngFor="let v of this.VATRates;" [value]="v" (click)="SelectSpendingPartner(s.Partner);">
                              {{v.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                          <mat-label>{{ 'PaidValue' | translate }}*</mat-label>
                          <input disabled="disabled" matInput placeholder="{{ 'PaidValue' | translate }}" autocomplete="off" [(ngModel)]="s.PaidValue" (change)="SelectSpendingPartner(s.Partner);">
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                          <mat-label>{{ 'VATPaidValue' | translate }}*</mat-label>
                          <input disabled="disabled" matInput placeholder="{{ 'VATPaidValue' | translate }}" autocomplete="off" [(ngModel)]="s.VATPaidValue">
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                          <mat-label>{{ 'Currency' | translate }}</mat-label>
                          <mat-select name="Currency" [(ngModel)]="s.Currency" [compareWith]="compareFn">
                            <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                              {{c.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                    ---
                  </div>
                </div>

                <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;border: none;">
                  <span class="DeductibilityTitle">{{'Deductibility' | translate}}:</span>

                  <div class="ReceptionProductsCol" style="width: 15%;margin-left: 2%;">
                      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                          <mat-label>{{ 'Deductibility' | translate }}</mat-label>
                          <input matInput placeholder="{{ 'Deductibility' | translate }}" autocomplete="off" [(ngModel)]="s.Deductibility.Value">
                      </mat-form-field>
                  </div>

                  <div class="ReceptionProductsCol" style="width: 15%;margin-left: 2%;">
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label>{{ 'Deductibility' | translate }}</mat-label>
                      <mat-select name="Deductibility" [compareWith]="compareFn" [(ngModel)]="s.Deductibility.Type">
                        <mat-option *ngFor="let d of this.DeductibilityTypes" [value]="d">
                          {{d.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

              <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;border: none;">
                <div class="ReceptionProductsCol" style="width: 35%;text-align: left;">
                  <mat-form-field appearance="outline" class="ReceptionProductsColSearch" style="width: 100%;">
                    <mat-label>{{ 'Description' | translate }}</mat-label>
                    <textarea autocomplete="off" matInput
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="5"
                              cdkAutosizeMaxRows="5"
                              [(ngModel)]="s.Description"></textarea>
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;padding-left: 1%;">
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                    <mat-select name="DocType" [compareWith]="compareFn" [(ngModel)]="s.DecimalPrecision">
                      <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p">
                        {{p.Meaning}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                    <mat-label>{{ 'Receptions.DocNumber' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'Receptions.DocNumber' | translate }}" autocomplete="off" [(ngModel)]="s.DocumentNumber">
                  </mat-form-field>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  <button (click)="currentSpending = s;RemoveSpendingFile(s.ID);" style="height: 30px;line-height: 30px;" mat-button color="warn" *ngIf="s.FilePath != null;">{{ 'RemoveFile' | translate }}</button>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  <form [formGroup]="newBlogForm" style="width: auto;float: left;">
                    <div style="margin-bottom: 10px;">
                        <input mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" style="width: 80%;">
                    </div>
                  </form>
                </div>
              </div>

            <div class="ReceptionProductsRow" style="padding-top: 0;" style="background: transparent;border: none;">
              <div class="ReceptionProductsCol" style="width: 50%;text-align: left;" *ngIf="s != null;">

                <button mat-button color="primary" (click)="AddUpdateSpending(s);" style="margin-right: 10px;">
                  <i class="material-icons">radio_button_on</i>
                  {{'UpdateSpending' | translate}}
                </button>
                <button mat-button color="warn" *ngIf="s.DocumentStatus.ID != -1;" (click)="CancelOrActivateSpending(s.ID, true);" style="margin-right: 10px;">
                  <i class="material-icons">close</i>
                  {{'Cancel' | translate}}
                </button>
                <button mat-button color="accent" *ngIf="s.DocumentStatus.ID == -1;" (click)="CancelOrActivateSpending(s.ID, false);" style="margin-right: 10px;">
                  <i class="material-icons">check</i>
                  {{'Activate' | translate}}
                </button>
                <button mat-button color="primary" *ngIf="s.FilePath != null;" (click)="DownloadSpendingFile(s);">
                  <i class="material-icons">cloud_queue</i>
                  {{'DownloadFile' | translate}}
                </button>
             
            </div>

            <div class="ReceptionProductsCol" style="width: 50%;text-align: right;padding-right: 10px;" *ngIf="s != null;">
              <button mat-button (click)="InitializeNewPayment(s);">
                <i class="material-icons">add</i>
                {{'AddPayment' | translate}}
              </button>

              <button mat-button (click)="GetSpendingPayments(s.ID);">
                <i class="material-icons">payment</i>
                {{'SeePayments' | translate}}
              </button>
            </div>

            </div>

              </div>
              </mat-expansion-panel>

            <mat-expansion-panel disabled *ngIf="this.Spendings != null && this.Spendings.length > 0 && !loading;">
              <mat-expansion-panel-header *ngFor="let Total of this.Totals; let i=index;">
                <mat-panel-description style="width: 5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 15%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 12.5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 12.5%;" class="panelTitleCol panelTotalCol">
                  Total:
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  <p>{{Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalVAT.Decimals}}</span></p>
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 7.5%;" class="panelTitleCol panelTotalCol">
                  {{Total.Currency.Name}}
                </mat-panel-description>
                <mat-panel-description style="width: 7.5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-expansion-panel-header *ngFor="let Total of this.PaidTotals; let i=index;">
                <mat-panel-description style="width: 5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 15%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 12.5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 12.5%;" class="panelTitleCol panelTotalCol">
                  {{'PaidTotal' | translate}}:
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                </mat-panel-description>
                <mat-panel-description style="width: 10%;" class="panelTitleCol panelTotalCol">
                  <p>{{Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalVAT.Decimals}}</span></p>
                </mat-panel-description>
                <mat-panel-description style="width: 7.5%;" class="panelTitleCol panelTotalCol">
                  {{Total.Currency.Name}}
                </mat-panel-description>
                <mat-panel-description style="width: 7.5%;" class="panelTitleCol panelTotalCol">
                  
                </mat-panel-description>
              </mat-expansion-panel-header>

            </mat-expansion-panel>

          </mat-accordion>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && Spendings.length > 0;">
      <div class="ReceptionProductsCol" style="width: 10%;">

      </div>
      <div class="ReceptionProductsCol" style="width: 20%;">
        <!-- <mat-slide-toggle (change)="GetSpendingsFiltered();" [(ngModel)]="Filter.ExchangeToTargetCurrency">{{'DisplaySingleCurrency' | translate}}</mat-slide-toggle> -->
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetSpendingsFiltered(this.Filter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </button>

        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
          <i class="material-icons">chevron_left</i>
        </button>
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetSpendingsFiltered(this.Filter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </button>

        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
          <i class="material-icons">chevron_right</i>
        </button>
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
          
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
          
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
          
      </div>
        </div>

        </div>
    </div>
</div>